export type QuerySelector = string | false | null | undefined;

// Note: this is primarily used to normalize querySelector so that it returns `undefined` instead of `null`.
// It also allows various "empty" values to be passed instead of requiring it to be a string.
export function querySelector<T extends HTMLElement>(
  selector: QuerySelector,
  context: ParentNode = document,
): T | undefined {
  // Immediately return if no value was provided.
  if (selector === false || selector === undefined || selector === null) {
    return undefined;
  }

  return context.querySelector<T>(selector) ?? undefined;
}
